import { ApiConnector, GET, POST, PUT, DELETE } from './requestV2.service';

export default (() => {
    const API = ApiConnector('/custom-task');
    const APIV2 = ApiConnector('/custom-task', true);
    return {
        CreateCustomTask: async data => await API(POST, '').call(data),
        CustomTasksList: async () => await API(GET, '', false).call(),
        GetCustomTaskById: async data => await API(GET, `${data}`).call(),
        GetCustomTaskInfo: async (id, query) => await API(GET, `/${id}/info`, false, query).call(),
        DeleteCustomTemplate: async query => await API(DELETE, '', false, query).call(),
        EditCustomTemplate: async data => await API(PUT, '').call(data),
        copyPrevioustDay: async data => await APIV2(POST, `/copy/yesterday`, false, false).call(data),
    };
})();
